






















































import { defineComponent } from "@vue/composition-api";
import { Dialog, List, PullRefresh, Search, Toast } from "vant";
import axios from "@/helpers/axios";
import "weui";
import weui from "weui.js";

interface Apply {
  agency_name: string;
  apply_id_name: string;
  apply_user_phone: string;
  create_time: string;
  id: number;
  status_name: string;
  type: number;
  type_name: string;
}

interface Type {
  id: number;
  name: string;
  steps: number;
}

interface Status {
  id: number;
  name: string;
}

interface WeuiPickItem {
  label: string;
  value: number;
}

export default defineComponent({
  components: {
    [PullRefresh.name]: PullRefresh,
    [List.name]: List,
    [Search.name]: Search
  },
  data() {
    return {
      refreshing: false,
      loading: false,
      finished: false,
      list: [] as Apply[],
      typeList: [] as Type[],
      typeId: -1,
      statusList: [] as Status[],
      statusId: 0,
      page: -1,
      businessId: 0,
      searchText: "",
      searchTextRaw: ""
    };
  },
  activated() {
    setTimeout(() => {
      this.onRefresh();
    }, 300);
  },
  methods: {
    search() {
      this.searchText = this.searchTextRaw;
      this.onRefresh();
    },
    onRefresh() {
      this.page = -1;
      window.scrollTo(0, 0);
      this.getData(true);
    },
    onLoad() {
      this.getData();
    },
    async getData(isRefresh = false) {
      const size = 7;
      const res = await axios
        .post("/api/manage/review/getList", {
          businessId: this.businessId,
          type: this.typeId === -1 ? "all" : this.typeId,
          status: this.statusId === -1 ? "all" : this.statusId,
          page: this.page + 1,
          size: size,
          number: this.searchText
        })
        .then(res => res?.data.data)
        .catch(() => undefined);
      this.loading = false;
      this.refreshing = false;
      if (!res) {
        Toast.fail("数据获取失败");
        return;
      }
      this.finished = res.list.length < size;

      this.page++;
      this.list = isRefresh ? res.list : this.list.concat(res.list);
      this.typeList = res.type_list;
      this.statusList = res.status_list;
    },
    async toDetail(apply: Apply) {
      const type = apply.type;
      const id = apply.id;

      if (type == 1) {
        let url = "";
        if (type == 1) {
          url = "/web/manager?page=manager_review_detail_charge&id=" + id;
        }
        this.$toUrl(url);
        const res = await Dialog.confirm({
          message: "请在新页面完成审批",
          confirmButtonText: "已完成审批"
        })
          .then(() => true)
          .catch(() => false);
        if (res === true) {
          this.onRefresh();
        }
      } else if (type == 2 || type == 3 || type == 4 || type == 8 || type == 7 || type == 6 || type == 9) {
        this.$router.push("/review/audit/detail/" + id);
      } else {
        Toast.fail("类型尚不支持");
      }
    },
    pickType() {
      weui.picker(
        [{ label: "全部", value: -1 }].concat(
          this.typeList.map(s => {
            return { label: s.name, value: s.id };
          })
        ),
        {
          id: "type_list_picker",
          defaultValue: [this.typeId],
          onConfirm: (result: WeuiPickItem[]) => {
            this.typeId = result[0].value;
            this.onRefresh();
          }
        }
      );
    },
    pickStatus() {
      weui.picker(
        [{ label: "全部", value: -1 }].concat(
          this.statusList.map(s => {
            return { label: s.name, value: s.id };
          })
        ),
        {
          id: "status_list_picker",
          defaultValue: [this.statusId],
          onConfirm: (result: WeuiPickItem[]) => {
            this.statusId = result[0].value;
            this.onRefresh();
          }
        }
      );
    }
  }
});
